/**
 * @generated SignedSource<<74bbf003fa9782337e08c6a39e56237a>>
 * @relayHash 8a04d1cadb8bd71fba1e0c68cc4a2dd5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/paymentDataFor3dsMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type MerchantAccountType = "DEALER_BILLING" | "TRANSACTION" | "%future added value";
export type PaymentDataFor3dsMutationInput = {
  accountType?: MerchantAccountType | null;
  clientMutationId?: string | null;
  currency?: Currency | null;
  paymentMethodToken?: string | null;
};
export type paymentDataFor3dsMutation$variables = {
  input: PaymentDataFor3dsMutationInput;
};
export type paymentDataFor3dsMutation$data = {
  readonly paymentDataFor3ds: {
    readonly clientToken: {
      readonly environment: string | null;
      readonly value: string | null;
    } | null;
    readonly paymentMethodNonce: {
      readonly bin: string | null;
      readonly nonce: string | null;
      readonly regulationEnvironment: string | null;
    } | null;
  } | null;
};
export type paymentDataFor3dsMutation = {
  response: paymentDataFor3dsMutation$data;
  variables: paymentDataFor3dsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PaymentDataFor3dsMutationPayload",
    "kind": "LinkedField",
    "name": "paymentDataFor3ds",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentMethodNonceData",
        "kind": "LinkedField",
        "name": "paymentMethodNonce",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nonce",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "regulationEnvironment",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Token",
        "kind": "LinkedField",
        "name": "clientToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "environment",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "paymentDataFor3dsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "paymentDataFor3dsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/paymentDataFor3dsMutation",
    "metadata": {},
    "name": "paymentDataFor3dsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c8c0113d231153d2b59a7e075f7e05e9";

export default node;
